import { z } from 'zod';
import { IsoDateTime, PageQuery, Uuid } from './common.js';
/** 'member' = a Companion app user acting as their member record (Phase 2, ADR 0015). */
export const ActorType = z.enum(['user', 'platform', 'partner', 'system', 'device', 'api', 'anonymous', 'member']);
export const AuditEntry = z.object({
    id: z.string(), // bigint as string
    tenantId: Uuid.nullable(),
    actorType: ActorType,
    actorId: Uuid.nullable(),
    /** Display name captured at the time (e.g. "Jane Smith" or "Platform support"). */
    actorLabel: z.string(),
    /** `<entity>.<verb>`, e.g. user.created, role.updated, settings.updated, auth.login_failed */
    action: z.string(),
    entityType: z.string(),
    entityId: z.string().nullable(),
    before: z.record(z.string(), z.unknown()).nullable(),
    after: z.record(z.string(), z.unknown()).nullable(),
    ip: z.string().nullable(),
    userAgent: z.string().nullable(),
    requestId: z.string().nullable(),
    at: IsoDateTime,
});
export const AuditQuery = PageQuery.extend({
    action: z.string().max(80).optional(),
    entityType: z.string().max(80).optional(),
    entityId: z.string().max(80).optional(),
    actorId: Uuid.optional(),
    from: IsoDateTime.optional(),
    to: IsoDateTime.optional(),
    order: z.enum(['asc', 'desc']).default('desc'),
});
/**
 * Keys never written to audit before/after (the audit writer removes them at any depth).
 * Add to this list rather than redacting by hand in each service.
 */
export const AUDIT_REDACT_KEYS = [
    'password',
    'passwordHash',
    'password_hash',
    'newPassword',
    'currentPassword',
    'totpSecret',
    'totp_secret_enc',
    'recoveryCodes',
    'recovery_codes',
    'token',
    'tokenHash',
    'token_hash',
    'secret',
    'secretHash',
    'secret_hash',
    'pinHash',
    'pin_hash',
];
//# sourceMappingURL=audit.js.map